export default __webpack_public_path__ + "static/media/SanathanTextile_Dec21'3526.029e56ab.jpg";